module.exports = __webpack_public_path__ + "img/phone.62ec98c0.png";